import axios from 'axios';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

const backendURL = process.env.REACT_APP_PUBLIC_BACKEND_URL;

if (!backendURL) {
  console.error('REACT_APP_PUBLIC_BACKEND_URL is not set in environment variables');
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Retrieve the auth instance
const auth = getAuth(app);

export const loginWithGoogle = async () => {
  try {
    const user = auth.currentUser;
    if (user) {
      const idToken = await user.getIdToken();
      const response = await axios.post(backendURL + '/login/google', { idToken });
      return response.data;
    } else {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: 'select_account' });
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();
      const response = await axios.post(backendURL + '/login/google', { idToken });
      return response.data;
    }
  } catch (error) {
    console.error('Error occurred during login:', error);
    throw new Error(error.response?.data?.message || error.message || 'Login failed');
  }
};

export const sendNewFaceToBackend = async (data) => {
  try {
    const response = await axios.post(backendURL + '/add_new_face', data);
    return response.data;
  } catch (error) {
    console.error('Error sending data to the backend:', error);
    const errorMessage = error.response?.data?.error || error.message || 'Failed to add face';
    throw new Error(errorMessage);
  }
};

export const getKnownFacesDataFromDB = async (data) => {
  try {
    const cacheName = "known-faces-data";
    const cache = await caches.open(cacheName);
    const url = backendURL + "/get_known_faces";

    // Check if the response is already in the cache
    const cacheResponse = await cache.match(url);

    if (cacheResponse) {
      try {
        // If the response is in the cache, return the cached data
        const jsonData = await cacheResponse.json();
        return jsonData;
      } catch (error) {
        console.error('Error parsing cached data:', error);
        // If there is an error parsing the cached data as JSON,
        // remove the invalid cache entry to avoid future errors
        await cache.delete(url);
      }
    }

    // If the response is not in the cache or there was an error parsing the data,
    // fetch the data from the backend
    const response = await axios.post(backendURL + '/get_known_faces', data);

    // Cache the response data as a JSON string for future use
    await cache.put(url, new Response(JSON.stringify(response.data)));

    return response.data;
  } catch (error) {
    console.error('Error getting known faces:', error);
    const errorMessage = error.response?.data?.error || error.message || 'Failed to retrieve faces';
    throw new Error(errorMessage);
  }
};
